import { CheckCircleIcon } from "@heroicons/react/24/solid"
import { ReactNode } from "react"
import { ActiveTab } from "./PuzzleScreen"

const Tab = ({
  index,
  title,
  activeTab,
  completed,
  children,
}: {
  index: number
  title: string
  activeTab: ActiveTab
  completed: boolean
  children: (active: boolean) => ReactNode
}) => {
  const active = activeTab === index

  const icon = completed ? (
    <CheckCircleIcon className="text-chessdrop-500 size-6" />
  ) : (
    <div className="flex size-6 items-center justify-center rounded-full border-2 border-gray-200 bg-white text-sm leading-none font-semibold text-gray-900">
      {index + 1}
    </div>
  )

  return (
    <div className="bg-white p-6">
      <div className="flex items-center gap-x-3">
        {icon}
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
      </div>
      {children(active)}
    </div>
  )
}

export default Tab
